export const MATCH_MODES = ["bot", "local"] as const;

export type MatchMode = (typeof MATCH_MODES)[number];

export function isMatchMode(value: unknown): value is MatchMode {
  return value === "bot" || value === "local";
}
